import React from 'react';
import whitelogo from '../assets/img/logo.png';
import { Link } from 'react-router-dom';

function Header () {
  return (
   <div className='header'>
      <div className='container-fluid'>
        <div className='row'>
          <div className='col-md-12'>
           <Link to="/"> <img src={whitelogo} alt='logo' className='logo' /></Link>

            <p>Version 1.5</p>

          </div>
        </div>
        </div>
   </div>
  )
}

export default Header;